<template>
  <div class="add-card">
    <ActionBar
      :title="$t('add_new_card')"
      @click="handleSelect"
    >
      <svg-icon slot="icon" name="card-icon" class-name="card-icon" />
    </ActionBar>
  </div>
</template>

<script>
import { CellItem } from 'mand-mobile'
import ActionBar from '@/components/ActionBar/index'

export default {
  name: 'CardSelectType',

  components: {
    ActionBar,
    [CellItem.name]: CellItem
  },

  methods: {
    handleSelect () {
      this.$router.push({ name: 'CardAddBankAccount' })
    }
  }
}
</script>

<style scoped>
.add-card {
  padding: 40px;
}

.card-icon {
  box-sizing: border-box;
  background: #fefe00;
  height: 64px;
  width: 64px;
  padding: 12px;
  color: #333;
  border-radius: 50%;
}
</style>
